import { useCallback } from 'react';
import { isValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { type FlagConfiguration, useFlagService } from '@atlassian/jira-flags';
import {
	type UpdateDatesProps,
	NotFoundError,
	useUpdateDates as useUpdateDatesService,
} from '../../services/update-dates/index.tsx';
import messages from './messages.tsx';

const UPDATE_FAILED_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.errorTitle,
	description: messages.errorMessage,
};

const ISSUE_NOT_FOUND: FlagConfiguration = {
	type: 'error',
	title: messages.notFoundErrorTitle,
	description: messages.notFoundErrorMessage,
};

export const useUpdateDates = () => {
	const updateDates = useUpdateDatesService();
	const { showFlag } = useFlagService();

	return useCallback(
		async ({ issueKey, issueId, newStartDate, newDueDate }: UpdateDatesProps) => {
			try {
				await updateDates({
					issueKey,
					issueId,
					newStartDate,
					newDueDate,
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				if (error instanceof NotFoundError) {
					showFlag(ISSUE_NOT_FOUND);
				} else if (isValidationError(error)) {
					showFlag({
						type: 'error',
						title: messages.errorTitle,
						description: error.message,
					});
				} else {
					showFlag(UPDATE_FAILED_FLAG);
				}
				throw error;
			}
		},
		[showFlag, updateDates],
	);
};
